import { Box, Text, Layer, Collapsible, Button } from "grommet";
import { Close, FormUp, Table } from "grommet-icons";
import React from "react";
import TocUnitData from "./TocUnitData";

const TocUnit = (props: any) => {
    // console.log("TocUnit", props.title)
    let ntable = props.ntable;
    let nrecord = props.nrecord;
    let tocid = props.tocid;
    let bookinfo = props.bookinfo
    // console.log("TocUnit bookinfo", bookinfo)

    const ModTitle = (props: any) => {
        let title = props.title;
        let lang = props.lang;
        let h = props.hierarchy;
        let title_div = title.split("/");
        let n_div = title_div.length;
        let first = "";
        let last = "";
        if (n_div > 2) {
            first = first + title_div[0];
            for (let i = 1; i < n_div - 1; i++) {
                let div_t = title_div[i];
                first = first + "/" + div_t;
            }
            first = first + "/ ";
        } else if (n_div > 1) {
            first = title_div[0] + "/ ";
            last = title_div[1];
        } else {
            last = title;
        }
        return (
        <Text size="1px">
            <Text size="7px" color="rgb(0,0,0,0.5)">
                {first}
            </Text>
            <Text size="13px" weight={h === 1 ? "bold" : "normal"}>
                {last}
            </Text>
        </Text>
        );
    };
    const TitleLine = () => (
        <>
            <Box
                width="50%"
                margin={{ horizontal: "5px" }}
                align="end"
                justify="center"
            >
            <ModTitle title={props.title} lang="zh" hierarchy={props.h} />
            </Box>
            <Box
                width="50%"
                margin={{ horizontal: "5px" }}
                align="center"
                justify="start"
                direction="row"
            >
            <ModTitle title={props.titleko} lang="ko" hierarchy={props.h} />
            {ntable > 0 && (
                <Box margin={{ horizontal: "10px" }} direction="row" align="center">
                    <Table size="6px" color="grey" />
                    <Text size="10px" color="grey" margin={{ left: "5px" }}>
                        {ntable}
                    </Text>
                </Box>
            )}
            </Box>
        </>
    );
    const [tocOpen, setTocOpen] = React.useState(false);

    return (
      <>
        {ntable > 0 || nrecord > 0 ? (
          <Box width="full" direction="column" justify="start" flex={false}>
            <Box
              width="full"
              style={{ minHeight: "25px" }}
              margin={props.h === 1 ? { vertical: "1px" } : { vertical: "0px" }}
              justify="start"
              direction="row"
              hoverIndicator={ntable > 0 ? true : false}
              focusIndicator={false}
              onClick={() => setTocOpen(!tocOpen)}
            >
              <TitleLine />
            </Box>
            <Collapsible open={tocOpen}>
              <Box
                justify="start"
                align='center'
                background={"rgb(255,255,255,0.3)"}
                pad="10px"
                margin={{ horizontal: "2px" }}
                direction='column'
              >
                <TocUnitData atoc={props} abook={props.bookinfo}/>
                <Button
                  alignSelf="end"
                  plain
                  onClick={() => setTocOpen(!tocOpen)}
                  icon={<FormUp size="10px" color="grey" />}
                  label={
                    <Text size="10px" color="grey">
                      닫기
                    </Text>
                  }
                />
              </Box>
            </Collapsible>
          </Box>
        ) : (
          <Box
            width="full"
            style={{ minHeight: "25px" }}
            margin={props.h === 1 ? { vertical: "5px" } : { vertical: "0px" }}
            align="center"
            justify="start"
            direction="row"
          >
            <TitleLine />
          </Box>
        )}
      </>
    );
}
export default TocUnit;